module.exports = __webpack_public_path__ + "img/pn.1e2a2409.svg";